<h3 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
  <span>Upload error</span>
</h3>
<p>
  There was an issue with your upload. Please try again. If the issue persists,
  please contact support at
  <a href="mailto:jsg.commerciallistsupport@gov.ab.ca" target="_top"></a>.
</p>

<div
  mat-dialog-actions
  fxLayout="row"
  fxLayoutAlign="end"
  style="padding-bottom: 20px"
>
  <button mat-stroked-button color="primary" mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="true">
    Try again
  </button>
</div>
